<template>
  <div class="containder" ref="containder">
    <div class="mask"></div>
    <div class="text" ref="text" v-fixed>
      <div class="short-desc">
        什么是龙虎榜
      </div>
      <div class="desc">
        每个交易日收盘后，沪深交易所会根据涨跌幅，换手率等指标公布当天满足上榜条件的股票榜单，即龙虎榜。
      </div>
      <div class="short-desc">
        怎么样可以上龙虎榜
      </div>
      <div class="desc">
        针对上榜原因，沪市每个条件各选前3名上榜，深市分主板、中小板、创业板每个条件各选前5名上榜，如果条件相同，则按照成交额和成交量选取，因此会出现一只个股同一天因多个原因上榜的情况。
      </div>
      <div class="short-desc">
        龙虎榜公布原因
      </div>
      <div class="desc">
        沪深交易所一般会在每个交易日17:00左右公布龙虎榜数据。一般来说，深交所在16:30左右，上交所在17:20左右。
      </div>
      <div class="short-desc">
        龙虎榜有什么用
      </div>
      <div class="desc">
        龙虎榜公布出来的往往都是大资金的营业部席位或者机构专用席位，一定程度上反映了其操作动向。1、有了营业部席位的上榜成交数据，通过历史统计，用户可以查看上榜席位或个股每次上榜时的买卖金额数据以及每次上榜后的历史表现。2、通过上榜营业部的操作风格和资金实力等多个维度，对上榜营业部进行多维度分析，方便用户通过不同维度了解上榜营业部，为选择可以跟踪的席位提供了数据支持。
      </div>
    </div>
    <div class='ok'>
      <img src="../../assets/know.png" @click="$emit('close')">
    </div>
    
  </div>
</template>

<script>
export default {
    directives: {
      fixed: {
        inserted () {
          let scrollTop = document.body.scrollTop
          document.body.style.cssText += 'position:fixed;width:100%;top:-' + scrollTop + 'px;'
        },
        unbind () {
          let body = document.body
          body.style.position = ''
          let top = body.style.top
          document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top)
          body.style.top = ''
        }
      }
    },
}
</script>
<style lang="stylus" scoped>
.containder
  position relative
  box-sizing border-box
  margin 0 auto
  height 3.7rem
  width 3rem
  padding-top .05rem
  background:rgba(255,255,255,1);
  border-radius .08rem
  .text
    overflow auto
    padding .15rem .2rem
    text-align center
    height 3.22rem
    -webkit-overflow-scrolling touch

    .short-desc
      font-size .17rem
      font-family PingFangSC-Medium,PingFang SC
      font-weight 500
      color rgba(10,20,40,1)
    .desc
      font-size .15rem
      font-family PingFangSC-Regular,PingFang SC
      font-weight 400
      color rgba(38,45,64,1)
      line-height .24rem
      margin .15rem 0
      padding-bottom .15rem
      border-bottom: 1px dashed #E6E6E6
      &:last-of-type
        padding-bottom 0
        margin-bottom .48rem
        border none
  .ok
    height .48rem
    width 100%
    position absolute
    top 3.22rem
    bottom 0
    img 
      height 100%
      width 100%
</style>